"use strict";

/*
 * Cargos widget for mainmenu
 */

(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var Widget = function Widget() {
    var me = this;
    this.updating = false;
    this.updating_callback = null; // функция, которую надо запустить после загрузки

    var options = {
      $el: null,
      $processed: null,
      $moved: null,
      $label: null,
      processedCargos: [],
      movedCargos: []
    };
    this.init = function () {
      options.$el = $('#cargo-widget');
      options.$processed = options.$el.find('#cargo-widget__processed');
      options.$moved = options.$el.find('#cargo-widget__move');
      options.$label = options.$el.find('#cargo-widget__label');
      var timer;
      options.$el.on("mouseover", function () {
        $.b2b.MainMenuWidgets.open("#cargo-widget");
        $('#dataCargoes').dxScrollView({
          scrollByThumb: true
        }).dxScrollView("instance");
        if (options.processedCargos.length > 9 || options.movedCargos.length > 9) {
          $('#dataCargoes').css('height', '215px');
          $('#dataCargoes').dxScrollView({
            showScrollbar: "always"
          });
        } else {
          $('#dataCargoes').css('height', 'auto');
          $('#dataCargoes').dxScrollView({
            showScrollbar: "never"
          });
        }
      }).on("mouseleave", function (e) {
        // при перетаскивании скроллера dxScrollView по какой-то причине вызывается mouseleave
        var mouseleaveTo = $(e)[0].toElement;
        if (!$(mouseleaveTo).hasClass('dx-gesture-cover')) $.b2b.MainMenuWidgets.closeWidget();
      });
    };

    // получение списка из корзины с сервера
    this.update = function (disableRefresh) {
      if ($(document).find("#cargo-widget").length > 0) {
        me.updating = true;
        $.b2b.ajax({
          url: '/CargoV2/GetCargosForWidget',
          success: function success(data) {
            me.updating = false;
            options.processedCargos = data.processedCargos;
            options.movedCargos = data.movedCargos;
            if (disableRefresh !== true) {
              me.refresh();
            }
            if (me.updating_callback) {
              me.updating_callback.call(me);
            }
          },
          error: function error(jqXHR) {
            me.updating = false;
            $.b2b.errors.showAjaxError(jqXHR);
          }
        });
      }
    };
    this.refresh = function () {
      if (options.$el.length > 0) {
        if (this.updating) {
          // еще идет загрузка с сервера
          this.updating_callback = function () {
            me.refresh();
          };
        }
        var ul;
        var countCargos = 0;
        if (me.updating === true) return;
        if (options.processedCargos.length > 0) {
          countCargos += options.processedCargos.length;
          ul = createList(options.processedCargos);
          options.$processed.append(ul);
        } else {
          options.$processed.append($('<div class="groupEmpty"> нет грузов</div>'));
        }
        if (options.movedCargos.length > 0) {
          countCargos += options.movedCargos.length;
          ul = createList(options.movedCargos);
          options.$moved.append(ul);
        } else {
          options.$moved.append($('<div class="groupEmpty"> нет грузов</div>'));
        }
        if (countCargos > 0) options.$label.html(countCargos);
      }
    };
    function createList(cargos) {
      var hideRequestsBillsReserves = $('.data.cargos').attr('hideRequestsBillsReserves');
      var ul = $('<ul/>');
      for (var i = 0; i < cargos.length; i++) {
        var cargo = cargos[i];
        var url = '/Cargo/Cargo/';
        if (cargo.Le2Id) url = '/Request/Positions?activeTab=cargoTab&focusedCargo=';
        if (hideRequestsBillsReserves) url = '/Request/Positions?activeTab=cargoTab&cargoId=';
        ul.append($('<li><a href=' + url + (cargo.IsLe2Cargo ? cargo.Le2Id + "&gridCollapsed=true" : cargo.Id) + ' target="_blank">#' + cargo.Number + '</a></li>'));
      }
      return ul;
    }
  };

  // Запускаем сразу, но отрисуется тогда, когда DOM построен
  var instance = new Widget();
  instance.update(true);
  $(document).ready(function () {
    instance.init();
    instance.refresh();
  });
})(jQuery);